export function converter(data_erp) {
    if (!data_erp){
      return ''
    }
  
    let input = data_erp
  
    let date = input.substring(0, 10)
    let hour = input.substring(11, 19)
    let aux = date.split('-').reverse().join('/');
    let formater = aux + ' ' + hour;
  
    return formater;
  }


// WEBPACK FOOTER //
// ./src/masks/masks.js